import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { compact } from 'lodash-es';
import { Badge, DropdownMenuItem, TableList, TableListActions, Typography } from 'seagull';
import { Archive, Edit, Eye, Trash, Unarchive } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { eligibilityTooltipTitle, eligibilityTooltipsTextsPath } from '../ClientsPage.utils';
import { ContactsCell } from './ContactsCell';
const CLIENT_STATUS_BADGE_SKIN = {
    active: 'success',
    archived: 'default'
};
export const GetClientRowTID = (parentTestId)=>getTestIds(parentTestId);
export function ClientRow(param) {
    let { client, testId, onEditClient, onViewClient, onArchiveClient, onRestoreClient, onDeleteClient } = param;
    var _client_type;
    const { t: clientsDashboardTexts } = useLocaleKeys('pages.clientsDashboard');
    const { t: eligibilityTooltipsTexts } = useLocaleKeys(eligibilityTooltipsTextsPath);
    const { ClientRowTestIds: TID } = useMemo(()=>GetClientRowTID(testId), [
        testId
    ]);
    const clientTypeText = clientsDashboardTexts.type[(_client_type = client.type) !== null && _client_type !== void 0 ? _client_type : 'business']();
    const isActive = client.status === 'active';
    const isArchived = client.status === 'archived';
    const canArchive = client.archiveEligibility.type !== 'notEligible';
    const canDelete = client.deleteEligibility.type !== 'notEligible';
    const archiveTooltipTitle = eligibilityTooltipTitle(client.archiveEligibility, 'archive', eligibilityTooltipsTexts);
    const deleteTooltipTitle = eligibilityTooltipTitle(client.deleteEligibility, 'delete', eligibilityTooltipsTexts);
    return /*#__PURE__*/ _jsx(TableList.Row, {
        rowId: client.id,
        testId: TID.Root(),
        onClick: ()=>onViewClient(client),
        items: [
            {
                value: /*#__PURE__*/ _jsx(Typography, {
                    ellipsis: true,
                    weight: "normal",
                    variant: "paragraph1",
                    testId: TID.Name(),
                    children: client.name
                })
            },
            {
                value: client.status ? /*#__PURE__*/ _jsx(Badge, {
                    skin: CLIENT_STATUS_BADGE_SKIN[client.status],
                    size: "small",
                    rounded: true,
                    outlined: true,
                    testId: TID.Status(),
                    children: clientsDashboardTexts.status[client.status]()
                }) : null
            },
            {
                value: /*#__PURE__*/ _jsx(Typography, {
                    weight: "light",
                    testId: TID.Type(),
                    children: clientTypeText
                })
            },
            {
                value: /*#__PURE__*/ _jsx(ContactsCell, {
                    client: client,
                    testId: TID.Contacts()
                })
            }
        ],
        actionColumn: /*#__PURE__*/ _jsx(TableListActions, {
            bi: {
                button: {
                    name: 'clients_view'
                },
                menuTrigger: {
                    name: 'clients_actions'
                }
            },
            testId: TID.Actions(),
            btnHeapId: "client-view-btn",
            buttonText: clientsDashboardTexts.actions.view(),
            buttonIcon: /*#__PURE__*/ _jsx(Eye, {
                testId: TID.ActionViewIcon()
            }),
            onClickButton: ()=>onViewClient(client),
            mobile: {
                title: client.name,
                subtitle: clientTypeText
            },
            children: compact([
                /*#__PURE__*/ _jsx(DropdownMenuItem, {
                    bi: {
                        name: 'client_edit'
                    },
                    iconStart: /*#__PURE__*/ _jsx(Edit, {}),
                    onClick: ()=>onEditClient(client),
                    testId: TID.ActionEdit(),
                    children: clientsDashboardTexts.actions.edit()
                }, "edit"),
                isActive && /*#__PURE__*/ _jsx(DropdownMenuItem, {
                    bi: {
                        name: 'client_archive'
                    },
                    iconStart: /*#__PURE__*/ _jsx(Archive, {}),
                    onClick: ()=>onArchiveClient(client),
                    testId: TID.ActionArchive(),
                    disabled: !canArchive || client.isSample,
                    tooltipProps: archiveTooltipTitle ? {
                        title: archiveTooltipTitle,
                        placement: 'bottom'
                    } : undefined,
                    children: clientsDashboardTexts.actions.archive()
                }, "archive"),
                isArchived && /*#__PURE__*/ _jsx(DropdownMenuItem, {
                    bi: {
                        name: 'client_restore'
                    },
                    iconStart: /*#__PURE__*/ _jsx(Unarchive, {}),
                    onClick: ()=>onRestoreClient(client),
                    testId: TID.ActionRestore(),
                    children: clientsDashboardTexts.actions.unarchive()
                }, "restore"),
                /*#__PURE__*/ _jsx(DropdownMenuItem, {
                    bi: {
                        name: 'client_delete'
                    },
                    iconStart: /*#__PURE__*/ _jsx(Trash, {}),
                    onClick: ()=>onDeleteClient(client),
                    testId: TID.ActionDelete(),
                    disabled: !canDelete || client.isSample,
                    skin: "error",
                    tooltipProps: deleteTooltipTitle ? {
                        title: deleteTooltipTitle,
                        placement: 'bottom'
                    } : undefined,
                    children: clientsDashboardTexts.actions.delete()
                }, "delete")
            ])
        })
    });
}
